"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ERROR = void 0;
var tslib_1 = require("tslib");
var ponyfill_1 = require("./ponyfill");
var middleware_1 = tslib_1.__importDefault(require("./middleware"));
var utils_1 = require("./utils");
var prep_1 = tslib_1.__importDefault(require("./options/prep"));
exports.DEFAULT_ERROR = 'errors.generic.global';
function getResultsFromResponse(response, options) {
    if (utils_1.shouldReturnPDF(response, options)) {
        return response.blob();
    }
    if (utils_1.shouldReturnText(response, options)) {
        return response.text();
    }
    return response.json().catch(function () { return ({ ok: response.status < 400 }); });
}
var getMessage = function (result) { return result.message || result.responseMessage || null; };
function dispatchError(response, options) {
    var fetchingErrorMiddleware = function (message, errorObj) {
        middleware_1.default.onFetchingError.forEach(function (cb) { return cb(options, message, errorObj); });
    };
    var error = {
        rawResponse: null,
        isError: true,
        responseError: response.message,
        responseContent: null,
        responseMessageCode: exports.DEFAULT_ERROR,
        responseMessage: null,
        responseCode: response.status || 500,
        _responseMessage: null
    };
    if (typeof response.json === 'function') {
        error.responseError = response.status + ": " + response.statusText;
        return getResultsFromResponse(response, options).then(function (result) {
            error.responseContent = result;
            if (!utils_1.shouldReturnText(response, options)) {
                error = tslib_1.__assign(tslib_1.__assign({}, error), { responseContent: result, 
                    // We are assuming that a 500+ error status will not have a user friendly translated error
                    // so we will null it out and return the default response code
                    responseMessage: response.status < 500 ? getMessage(result) : null, _responseMessage: getMessage(result) });
                // We are assuming a few things here. If the backend responds with a `responseMessage` or `message`
                // we are expecting the message to have been translated. If there is a message at this point, do not
                // pass in the `responseMessageCode`
                if (error.responseMessage) {
                    error.responseMessageCode = null;
                }
            }
            fetchingErrorMiddleware(error.responseMessage, error);
            // fetchingErrorMiddleware will stuff the error in redux state, attach the response after the error callback
            error.rawResponse = response;
            return error;
        });
    }
    fetchingErrorMiddleware(null, error);
    error.rawResponse = response;
    return Promise.resolve(error);
}
function clientFetch(userOptions) {
    var options = prep_1.default(userOptions);
    middleware_1.default.onFetching.forEach(function (cb) { return cb(options); });
    return ponyfill_1.fetch(options.url, options).then(function (response) {
        if (!response.ok) {
            throw response;
        }
        return getResultsFromResponse(response, options).then(function (result) {
            middleware_1.default.onFetched.forEach(function (cb) { return cb(options, result); });
            return result;
        });
    }).catch(function (response) {
        return dispatchError(response, options).then(function (error) {
            if (!options.catchError) {
                throw error;
            }
            return error;
        });
    });
}
exports.default = clientFetch;
//# sourceMappingURL=fetch.js.map